import React, { useState } from 'react';
import { Star, ChevronLeft, ChevronRight, Quote } from 'lucide-react';

const testimonials = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    location: 'Sydney, NSW',
    rating: 5,
    text: "FindMeAgent connected us with an amazing local agent who sold our home for $85,000 above reserve. The whole process was stress-free and we couldn't be happier!",
    propertyType: 'Sold 4 Bedroom House',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 2,
    name: 'Michael Chen',
    location: 'Melbourne, VIC',
    rating: 5,
    text: "As a first-time buyer, I was overwhelmed. The agent FindMeAgent matched me with was patient, knowledgeable, and found me the perfect apartment within my budget.",
    propertyType: 'Bought 2 Bedroom Unit',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 3,
    name: 'Emma & David Thompson',
    location: 'Brisbane, QLD',
    rating: 5,
    text: "We were relocating from interstate and needed an agent who really knew the local market. FindMeAgent delivered exactly that. Highly recommend!",
    propertyType: 'Bought Family Home',
    image: 'https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 4,
    name: 'James Wilson',
    location: 'Perth, WA',
    rating: 5,
    text: "The agent was professional, responsive, and achieved a great result. What I loved most was there was no pressure - I felt in control the whole time.",
    propertyType: 'Sold Investment Property',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
  },
  {
    id: 5,
    name: 'Lisa Anderson',
    location: 'Gold Coast, QLD',
    rating: 5,
    text: "After a bad experience with another agent, I was hesitant. FindMeAgent matched me with someone who truly cared. Sold in 3 weeks above asking price!",
    propertyType: 'Sold Beachfront Apartment',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face'
  }
];

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        <div className="testimonials-header">
          <h2 className="testimonials-title">What Our Clients Say</h2>
          <p className="testimonials-subtitle">Real stories from Australians we've helped find their perfect agent</p>
        </div>

        <div className="testimonials-carousel">
          <button className="carousel-btn carousel-btn-prev" onClick={prevTestimonial} aria-label="Previous testimonial">
            <ChevronLeft size={24} />
          </button>

          <div className="testimonial-card">
            <div className="testimonial-quote-icon">
              <Quote size={40} />
            </div>
            
            <div className="testimonial-content">
              <div className="testimonial-rating">
                {[...Array(currentTestimonial.rating)].map((_, i) => (
                  <Star key={i} size={20} fill="#D4AF37" color="#D4AF37" />
                ))}
              </div>
              
              <p className="testimonial-text">"{currentTestimonial.text}"</p>
              
              <div className="testimonial-author">
                <img 
                  src={currentTestimonial.image} 
                  alt={currentTestimonial.name}
                  className="testimonial-avatar"
                />
                <div className="testimonial-author-info">
                  <h4 className="testimonial-name">{currentTestimonial.name}</h4>
                  <p className="testimonial-location">{currentTestimonial.location}</p>
                  <p className="testimonial-property">{currentTestimonial.propertyType}</p>
                </div>
              </div>
            </div>
          </div>

          <button className="carousel-btn carousel-btn-next" onClick={nextTestimonial} aria-label="Next testimonial">
            <ChevronRight size={24} />
          </button>
        </div>

        <div className="testimonial-dots">
          {testimonials.map((_, index) => (
            <button
              key={index}
              className={`testimonial-dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => setCurrentIndex(index)}
              aria-label={`Go to testimonial ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
